import styled from 'styled-components';

import shouldForwardProp from 'configs/shouldForwardProp';

import { TPageHeaderProps } from './PageHeader.types';

type TSpacingKey = NonNullable<TPageHeaderProps['paddingX']>;

export const StyledPageHeader = styled.header.withConfig({ shouldForwardProp })<{
  $paddingX: TSpacingKey;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 ${({ theme, $paddingX }) => theme.spacing[$paddingX]}px;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  z-index: ${({ theme }) => theme.zIndex.header};
`;
